/* eslint-disable */
export default {
  confirmationInfo: '先前通話未儲存的編輯將會遺失，確定要編輯新的通話？',
  log: '記錄',
  save: '儲存並編輯新通話',
  discard: '捨棄並編輯新通話',
  stay: '繼續先前的編輯',
} as const;

// @key: @#@"confirmationInfo"@#@ @source: @#@"Your unsaved edits on the previous call will be lost, are you sure you want to work on the new call?"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save & Work on New"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard & Work on New"@#@
// @key: @#@"stay"@#@ @source: @#@"Stay on Previous Work"@#@
